/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Endpoint_Not_MeasuredInputs */

const en_app_endpoint_not_measured = /** @type {(inputs: App_Endpoint_Not_MeasuredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`not yet measured`)
};

const zh_hans1_app_endpoint_not_measured = /** @type {(inputs: App_Endpoint_Not_MeasuredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未测量`)
};

const pt_br2_app_endpoint_not_measured = /** @type {(inputs: App_Endpoint_Not_MeasuredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ainda não medido`)
};

const es_app_endpoint_not_measured = /** @type {(inputs: App_Endpoint_Not_MeasuredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aún no medido`)
};

const fr_app_endpoint_not_measured = /** @type {(inputs: App_Endpoint_Not_MeasuredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pas encore mesuré`)
};

const de_app_endpoint_not_measured = /** @type {(inputs: App_Endpoint_Not_MeasuredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`noch nicht gemessen`)
};

const ru_app_endpoint_not_measured = /** @type {(inputs: App_Endpoint_Not_MeasuredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ещё не измерено`)
};

const it_app_endpoint_not_measured = /** @type {(inputs: App_Endpoint_Not_MeasuredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`non ancora misurato`)
};

/**
* | output |
* | --- |
* | "not yet measured" |
*
* @param {App_Endpoint_Not_MeasuredInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_endpoint_not_measured = /** @type {((inputs?: App_Endpoint_Not_MeasuredInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Endpoint_Not_MeasuredInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_endpoint_not_measured(inputs)
	if (locale === "pt-BR") return pt_br2_app_endpoint_not_measured(inputs)
	if (locale === "es") return es_app_endpoint_not_measured(inputs)
	if (locale === "fr") return fr_app_endpoint_not_measured(inputs)
	if (locale === "de") return de_app_endpoint_not_measured(inputs)
	if (locale === "ru") return ru_app_endpoint_not_measured(inputs)
	if (locale === "it") return it_app_endpoint_not_measured(inputs)
	return en_app_endpoint_not_measured(inputs)
});